/**
 * Arabic for the interface, keyed by the English text it replaces.
 * Generated for page titles and navigation; shared strings are listed by hand.
 * A string missing here simply shows in English.
 */
export const AR: Record<string, string> = {
  "14 days": "14 يوماً",
  "2m": "قبل دقيقتين",
  "5 channels": "5 قنوات",
  "5% VAT": "ضريبة 5%",
  "6m": "قبل ٦ دقائق",
  "A claim becomes a cost when it is approved — that is when it reaches the books.": "تصبح المطالبة تكلفة عند اعتمادها، وعندها تدخل الدفاتر.",
  "A dynamic segment re-runs every time it is used; a static list is frozen the moment it is saved. Both matter.": "الشريحة الديناميكية تُحدَّث في كل استخدام، والقائمة الثابتة تُجمَّد لحظة حفظها. ولكلٍّ منهما فائدته.",
  "A receipt is on its way. You can close this page.": "الإيصال في الطريق إليك. يمكنك إغلاق هذه الصفحة.",
  "A shared inbox and approved-template broadcasts, through Meta's Cloud API.": "صندوق وارد مشترك ورسائل جماعية بقوالب معتمدة عبر واجهة Meta السحابية.",
  "AED invoicing": "فواتير بالدرهم",
  "AMCs and support retainers — what is covered, how many hours are left, and when it ends.": "عقود الصيانة والدعم: ما تشمله، والساعات المتبقية، وموعد انتهائها.",
  "About this company": "عن هذه الشركة",
  "About this contact": "عن جهة الاتصال",
  "About this deal": "عن هذه الصفقة",
  "About this lead": "عن هذا العميل المحتمل",
  "Activities": "الأنشطة",
  "Activity & goals": "النشاط والأهداف",
  "Add": "إضافة",
  "Add company": "إضافة شركة",
  "Add contact": "إضافة جهة اتصال",
  "Add deal": "إضافة صفقة",
  "Add lead": "إضافة عميل محتمل",
  "Add one line to your website to count visitors, show your pop-up forms, and see the pages every lead read before they wrote to you.": "أضف سطراً واحداً إلى موقعك لعدّ الزوار وإظهار النماذج المنبثقة ومعرفة الصفحات التي قرأها كل عميل محتمل قبل أن يراسلك.",
  "Added": "أُضيف",
  "Administration": "الإدارة",
  "Aisha K.": "عائشة ك.",
  "All companies": "كل الشركات",
  "All contacts": "كل جهات الاتصال",
  "All deals": "كل الصفقات",
  "All leads": "كل العملاء المحتملين",
  "All topics": "كل المواضيع",
  "Amount": "المبلغ",
  "Any": "الكل",
  "Append-only record of every sensitive change. It cannot be edited or deleted from the application.": "سجل لكل تغيير حساس، يُضاف إليه فقط ولا يمكن تعديله أو حذفه من التطبيق.",
  "Approving an invoice fixes it and posts it to the ledger.": "اعتماد الفاتورة يثبّتها ويقيّدها في دفتر الأستاذ.",
  "Ask Dovo": "اسأل دوفو",
  "Ask about your pipeline or how to do something in DovoCRM.": "اسأل عن مسار مبيعاتك أو عن كيفية القيام بأي شيء في DovoCRM.",
  "Ask an administrator if you think you should. They can grant it from Roles.": "اطلب من المسؤول إن كنت تعتقد أنك تحتاجها، فبإمكانه منحها من الأدوار.",
  "Ask anything…": "اسأل أي شيء…",
  "Audiences": "الجماهير",
  "Audit log": "سجل التدقيق",
  "Authentication code": "رمز التحقق",
  "Automation": "الأتمتة",
  "Automation rules": "قواعد الأتمتة",
  "Back": "رجوع",
  "Back to home": "العودة إلى الرئيسية",
  "Back to site": "العودة إلى الموقع",
  "Board": "لوحة",
  "Booking…": "جارٍ الحجز…",
  "Bots that answer first — on the website chat, WhatsApp, Telegram, Messenger and Instagram — ask what you need to know, and hand over to a person.": "روبوتات تردّ أولاً على دردشة الموقع وواتساب وتيليجرام وماسنجر وإنستغرام، وتسأل ما تحتاج معرفته، ثم تحوّل المحادثة إلى موظف.",
  "Bring in leads, contacts, companies or deals from Excel or CSV — columns are matched for you, duplicates are caught, and every import can be undone.": "استورد العملاء المحتملين وجهات الاتصال والشركات والصفقات من Excel أو CSV؛ تُطابَق الأعمدة تلقائياً وتُكتشف التكرارات، ويمكن التراجع عن أي استيراد.",
  "Budget": "الميزانية",
  "Budgets": "الميزانيات",
  "Budgets and standing costs": "الميزانيات والتكاليف الثابتة",
  "Build a report from any of the data you already have access to, then save it or send it on a schedule.": "أنشئ تقريراً من أي بيانات يحق لك الوصول إليها، ثم احفظه أو أرسله وفق جدول.",
  "Built for the UAE": "صُمم للإمارات",
  "Built for the UAE: AED, Arabic, Emirates and free zones.": "مصمم للإمارات: الدرهم والعربية والإمارات والمناطق الحرة.",
  "CRM": "إدارة العملاء",
  "Calls": "المكالمات",
  "Calls, emails, meetings, tasks and deals won per person, against the targets set for the month.": "المكالمات والرسائل والاجتماعات والمهام والصفقات المكسوبة لكل موظف، مقارنةً بأهداف الشهر.",
  "Came in through": "وصل عبر",
  "Campaign": "الحملة",
  "Campaign pages built from blocks, with your form on them. Published at dovocrm.com/lp/your-page — views and conversions counted.": "صفحات حملات تُبنى من أقسام جاهزة مع نموذجك، تُنشر على dovocrm.com/lp وتُحتسب الزيارات والتحويلات.",
  "Campaigns": "الحملات",
  "Can I book a demo for Thursday?": "هل يمكنني حجز عرض توضيحي يوم الخميس؟",
  "Cancel": "إلغاء",
  "Cash forecast": "توقعات النقد",
  "Cash, what you are owed, what you owe, and what it is costing.": "النقد، وما لك، وما عليك، وكم يكلّف ذلك.",
  "Cash-flow forecast": "توقعات التدفق النقدي",
  "Change time": "تغيير الوقت",
  "Channels": "القنوات",
  "Choose…": "اختر…",
  "Clear": "مسح",
  "Clear all": "مسح الكل",
  "Click Call on any lead, contact or deal to dial from your phone and log it. Every call lands here and on the record.": "اضغط «اتصال» على أي عميل أو صفقة للاتصال من هاتفك وتسجيل المكالمة. تظهر كل مكالمة هنا وفي السجل.",
  "Client portal access": "الوصول إلى بوابة العملاء",
  "Close": "إغلاق",
  "Close date": "تاريخ الإغلاق",
  "Collapse": "طي",
  "Collapse menu": "طي القائمة",
  "Columns": "الأعمدة",
  "Commerce": "التجارة",
  "Committed work by status. The backlog is its own view — nothing is on the board until it is in a sprint.": "الأعمال الملتزم بها حسب الحالة. للأعمال المؤجلة عرض خاص، ولا يظهر شيء على اللوحة قبل إدراجه في دورة عمل.",
  "Companies": "الشركات",
  "Company": "الشركة",
  "Company details, security policy and document numbering.": "بيانات الشركة وسياسة الأمان وترقيم المستندات.",
  "Confirm booking": "تأكيد الحجز",
  "Confirming your payment…": "جارٍ تأكيد الدفع…",
  "Connect your office PBX. Incoming calls pop up for the right person with the customer’s record, every call and its recording is logged automatically, and missed calls from new numbers become incoming leads.": "اربط مقسم الهاتف في مكتبك. تظهر المكالمات الواردة للموظف المعني مع سجل العميل، وتُسجَّل كل مكالمة وتسجيلها تلقائياً، وتتحول المكالمات الفائتة من أرقام جديدة إلى عملاء محتملين.",
  "Connect your own mailbox. Emails with your customers are logged on their records, replies stop sequences, you can send as yourself, and booking pages skip times your calendar is busy.": "اربط بريدك الخاص لتُسجَّل رسائلك مع العملاء في سجلاتهم، وتتوقف التسلسلات عند الرد، وترسل باسمك، وتتجنب صفحات الحجز أوقات انشغالك.",
  "Consent": "الموافقة",
  "Contact": "جهة اتصال",
  "Contacts": "جهات الاتصال",
  "Contracts": "العقود",
  "Contracts, reports and anything else shared with you. Every download is recorded.": "العقود والتقارير وكل ما تمت مشاركته معك. يُسجَّل كل تنزيل.",
  "Conversations": "المحادثات",
  "Convert": "تحويل",
  "Create": "إنشاء",
  "Create date": "تاريخ الإنشاء",
  "Create your workspace": "أنشئ مساحة عملك",
  "Created": "تاريخ الإنشاء",
  "Credit limit": "حد الائتمان",
  "Currency": "العملة",
  "Custom objects": "الكائنات المخصصة",
  "Dark mode": "الوضع الداكن",
  "Dashboard": "لوحة التحكم",
  "Dashboards": "لوحات المعلومات",
  "Deal": "صفقة",
  "Deal name": "اسم الصفقة",
  "Deal owner": "مالك الصفقة",
  "Deal pipeline setup": "إعداد مسار الصفقات",
  "Deal stage": "مرحلة الصفقة",
  "Deal type": "نوع الصفقة",
  "Deals": "الصفقات",
  "Deals move on boards; quotes and invoices go out with 5% VAT.": "الصفقات تتحرك على اللوحات، وعروض الأسعار والفواتير تُرسل مع ضريبة 5%.",
  "Decision maker": "صانع قرار",
  "Decision makers": "صناع القرار",
  "Delete": "حذف",
  "Delete {count} {noun}? They go to the recycle bin.": "حذف {count} {noun}؟ ستنتقل إلى سلة المحذوفات.",
  "Deleted": "تم الحذف",
  "Department": "القسم",
  "Digital pipeline": "المسار الرقمي",
  "Do you deliver to Abu Dhabi?": "هل توصلون إلى أبوظبي؟",
  "Documents": "المستندات",
  "Download": "تنزيل",
  "Download PDF": "تنزيل PDF",
  "Drag deals here": "اسحب الصفقات إلى هنا",
  "Drag leads here": "اسحب العملاء المحتملين إلى هنا",
  "Edit": "تعديل",
  "Edit columns": "تعديل الأعمدة",
  "Edit pipeline stages": "تعديل مراحل المسار",
  "Eight weeks ahead in detail, then monthly to twelve months. Every figure comes from a record you can open.": "ثمانية أسابيع قادمة بالتفصيل، ثم شهرياً حتى اثني عشر شهراً. كل رقم مأخوذ من سجل يمكنك فتحه.",
  "Email": "البريد الإلكتروني",
  "Email and WhatsApp broadcasts. Every send is checked against the suppression list, consent and the weekly frequency cap first.": "رسائل جماعية عبر البريد وواتساب. يُفحص كل إرسال أولاً مقابل قائمة الحظر والموافقة وحد التكرار الأسبوعي.",
  "Email campaigns": "حملات البريد",
  "Email opt-in": "موافقة البريد",
  "Emails & templates": "الرسائل والقوالب",
  "Enroll in sequence": "إضافة إلى تسلسل",
  "Every channel you connect sends its conversations to the inbox, and a stranger's first message to the Incoming column.": "كل قناة تربطها ترسل محادثاتها إلى صندوق الوارد، وأول رسالة من شخص جديد إلى عمود «الوارد».",
  "Every company workspace on DovoCRM.": "كل مساحات عمل الشركات على DovoCRM.",
  "Every conversation.": "كل محادثة.",
  "Every deal.": "كل صفقة.",
  "Every email sent from the CRM with who opened, clicked and replied — and the templates and #snippets the team reuses.": "كل رسالة أُرسلت من النظام مع من فتحها ونقر عليها ورد، والقوالب والمقتطفات التي يعيد الفريق استخدامها.",
  "Everyone with access to this workspace, and what they can do.": "كل من يملك صلاحية الوصول إلى هذه المساحة، وما يمكنه فعله.",
  "Everything filed, versioned, and reachable only through a link that expires.": "كل شيء محفوظ بإصداراته، ولا يُوصل إليه إلا برابط تنتهي صلاحيته.",
  "Everything here is derived from the ledger, so it can always be traced back.": "كل ما هنا مأخوذ من دفتر الأستاذ، لذا يمكن تتبّعه دائماً.",
  "Expand menu": "توسيع القائمة",
  "Expenses": "المصروفات",
  "Export": "تصدير",
  "Finance": "المالية",
  "Finance reports": "التقارير المالية",
  "Finance settings": "إعدادات المالية",
  "Finance setup": "إعداد المالية",
  "Financial reports": "التقارير المالية",
  "Finding free times…": "جارٍ البحث عن أوقات متاحة…",
  "Follow-up emails and call tasks spaced over days, sent as you on working days. Anyone who replies or books a meeting comes out on their own.": "رسائل متابعة ومهام اتصال موزعة على أيام، تُرسل باسمك في أيام العمل. ويخرج تلقائياً كل من يرد أو يحجز اجتماعاً.",
  "Forgot password?": "نسيت كلمة المرور؟",
  "Forgot your password?": "نسيت كلمة المرور؟",
  "Forms & pop-ups": "النماذج والنوافذ المنبثقة",
  "Free trial": "تجربة مجانية",
  "Generate an NDA or a statement of work from a record, then send it to be signed.": "أنشئ اتفاقية سرية أو بيان عمل من السجل، ثم أرسله للتوقيع.",
  "Help articles for customers and the team. Published ones appear in your help centre; internal ones only for staff.": "مقالات مساعدة للعملاء والفريق. المنشورة تظهر في مركز المساعدة، والداخلية للموظفين فقط.",
  "Help centre": "مركز المساعدة",
  "Hi! How can I help?": "مرحباً! كيف يمكنني المساعدة؟",
  "Home": "الرئيسية",
  "How can we help?": "كيف يمكننا مساعدتك؟",
  "How do I build a sequence?": "كيف أنشئ تسلسلاً؟",
  "How do I connect WhatsApp to the inbox?": "كيف أربط واتساب بصندوق الوارد؟",
  "How do I send an invoice with VAT?": "كيف أرسل فاتورة مع ضريبة القيمة المضافة؟",
  "Import": "استيراد",
  "Import & export": "الاستيراد والتصدير",
  "Inbox": "صندوق الوارد",
  "Inbox channels": "قنوات صندوق الوارد",
  "Instagram": "إنستغرام",
  "Invoice": "فاتورة",
  "Invoices": "الفواتير",
  "Is the trade licence package still AED 12,500?": "هل باقة الرخصة التجارية ما زالت بـ 12,500 درهم؟",
  "Journeys": "الرحلات",
  "Knowledge base": "قاعدة المعرفة",
  "Landing pages": "الصفحات المقصودة",
  "Language": "اللغة",
  "Lead": "عميل محتمل",
  "Lead ads": "إعلانات العملاء المحتملين",
  "Lead owner": "مالك العميل المحتمل",
  "Lead pipeline": "مسار العملاء المحتملين",
  "Lead pipeline setup": "إعداد مسار العملاء المحتملين",
  "Lead status": "حالة العميل المحتمل",
  "Leads": "العملاء المحتملون",
  "Leads from Facebook, Instagram, Google and TikTok ad forms land in Incoming straight away, tagged with the campaign — no CSV downloads.": "يصل العملاء المحتملون من نماذج إعلانات فيسبوك وإنستغرام وجوجل وتيك توك إلى «الوارد» فوراً مع اسم الحملة، دون تنزيل ملفات.",
  "Lifecycle": "دورة الحياة",
  "Lifecycle stage": "مرحلة دورة الحياة",
  "Light mode": "الوضع الفاتح",
  "Loading…": "جارٍ التحميل…",
  "Location": "الموقع",
  "Lost": "خاسرة",
  "Marketing": "التسويق",
  "Marketing hub": "مركز التسويق",
  "Marketing setup": "إعداد التسويق",
  "Meetings": "الاجتماعات",
  "Menu": "القائمة",
  "Money received, and which invoices it settles. Anything unapplied stays as client credit.": "المبالغ المستلمة والفواتير التي تسددها. ويبقى غير المخصص رصيداً للعميل.",
  "My account": "حسابي",
  "My companies": "شركاتي",
  "My day": "يومي",
  "My deals": "صفقاتي",
  "My email & calendar": "بريدي وتقويمي",
  "My leads": "عملائي المحتملون",
  "Name": "الاسم",
  "Named groups with a lead. Teams drive pipeline roll-up, ticket routing and the team permission scope.": "مجموعات مسماة لها قائد. تحدد الفرق تجميع المسارات وتوجيه التذاكر ونطاق صلاحيات الفريق.",
  "New": "جديد",
  "New chat": "محادثة جديدة",
  "New to DovoCRM?": "جديد على DovoCRM؟",
  "Next": "التالي",
  "No": "لا",
  "No free times this week — try the next one.": "لا توجد أوقات متاحة هذا الأسبوع، جرّب الأسبوع التالي.",
  "No money was taken. You can try again.": "لم يُخصم أي مبلغ. يمكنك المحاولة مجدداً.",
  "No owner": "بدون مالك",
  "Nothing found. Try other words.": "لم يُعثر على شيء. جرّب كلمات أخرى.",
  "Nothing here yet": "لا يوجد شيء هنا بعد",
  "Notifications": "الإشعارات",
  "Omar R.": "عمر ر.",
  "One inbox": "صندوق وارد واحد",
  "One place.": "في مكان واحد.",
  "Open": "مفتوحة",
  "Organisation": "المؤسسة",
  "Overview": "نظرة عامة",
  "Owner": "المالك",
  "Password": "كلمة المرور",
  "Payment cancelled": "تم إلغاء الدفع",
  "Payment did not go through": "لم تتم عملية الدفع",
  "Payment not completed": "لم يكتمل الدفع",
  "Payment received": "تم استلام الدفعة",
  "Payment terms": "شروط الدفع",
  "Payments": "المدفوعات",
  "People": "الأشخاص",
  "Phone": "الهاتف",
  "Phone number": "رقم الهاتف",
  "Phone system": "نظام الهاتف",
  "Pick a day": "اختر يوماً",
  "Pipeline": "المسار",
  "Plan & billing": "الخطة والفوترة",
  "Platform": "المنصة",
  "Platform console": "لوحة المنصة",
  "Playbooks": "أدلة المكالمات",
  "Portal access": "الوصول إلى البوابة",
  "Prev": "السابق",
  "Previous": "السابق",
  "Primary company": "الشركة الرئيسية",
  "Profile & preferences": "الملف الشخصي والتفضيلات",
  "Projects": "المشاريع",
  "Proposals sent to clients, with a link they can accept from.": "عروض مرسلة إلى العملاء مع رابط للموافقة عليها.",
  "Qualified": "مؤهل",
  "Quote": "عرض سعر",
  "Quotes": "عروض الأسعار",
  "Raise something, follow it, and see the time we have promised you.": "ارفع طلبك وتابعه واطّلع على الوقت الذي التزمنا به.",
  "Recurring revenue": "الإيرادات المتكررة",
  "Recycle bin": "سلة المحذوفات",
  "Related articles": "مقالات ذات صلة",
  "Reporting": "التقارير",
  "Reports": "التقارير",
  "Requirement": "المتطلبات",
  "Role": "الدور",
  "Roles": "الأدوار",
  "Roles are data, not code. Adjust a system role or build your own.": "الأدوار بيانات وليست برمجة. عدّل دوراً جاهزاً أو أنشئ دورك الخاص.",
  "SLA clocks count working hours only, and stop while a ticket is waiting on the client.": "تحتسب مؤقتات اتفاقية مستوى الخدمة ساعات العمل فقط، وتتوقف أثناء انتظار رد العميل.",
  "Sales": "المبيعات",
  "Sales hub": "مركز المبيعات",
  "Sales tools & insights": "أدوات المبيعات والرؤى",
  "Salesbots": "روبوتات المبيعات",
  "Save": "حفظ",
  "Score": "التقييم",
  "Search": "بحث",
  "Search DovoCRM": "ابحث في DovoCRM",
  "Search articles…": "ابحث في المقالات…",
  "Search or jump to…": "ابحث أو انتقل إلى…",
  "Search…": "بحث…",
  "Segments": "الشرائح",
  "Send": "إرسال",
  "Sending…": "جارٍ الإرسال…",
  "Sequences": "التسلسلات",
  "Service": "الخدمة",
  "Service desk": "مكتب الخدمة",
  "Service setup": "إعداد الخدمة",
  "Services": "الخدمات",
  "Set status…": "تعيين الحالة…",
  "Settings": "الإعدادات",
  "Sign in": "تسجيل الدخول",
  "Sign in to your DovoCRM workspace.": "سجّل الدخول إلى مساحة عملك في DovoCRM.",
  "Sign in to your workspace": "سجّل الدخول إلى مساحة عملك",
  "Sign out": "تسجيل الخروج",
  "Signing in…": "جارٍ تسجيل الدخول…",
  "Since": "منذ",
  "Social posts": "منشورات التواصل",
  "Something went wrong": "حدث خطأ ما",
  "Source": "المصدر",
  "Stage": "المرحلة",
  "Stage history": "سجل المراحل",
  "Start a free trial": "ابدأ تجربة مجانية",
  "Start free trial": "ابدأ التجربة المجانية",
  "Status": "الحالة",
  "Subscriptions": "الاشتراكات",
  "Support": "الدعم",
  "TRN": "الرقم الضريبي",
  "Table": "جدول",
  "Tax, banking and the chart of accounts every posting rule uses.": "الضرائب والحسابات البنكية ودليل الحسابات الذي تستخدمه قواعد القيد.",
  "Team chat": "دردشة الفريق",
  "Teams": "الفرق",
  "Templates & signing": "القوالب والتوقيع",
  "Templates and signatures": "القوالب والتوقيعات",
  "Terms": "الشروط",
  "Thanks for letting us know.": "شكراً لإخبارنا.",
  "The AI assistant is not switched on for this workspace yet.": "المساعد الذكي غير مفعّل في مساحة العمل هذه بعد.",
  "The questions to ask on a call, in order. Reps open one from the record; the answers are saved to its timeline.": "الأسئلة التي تُطرح في المكالمة بالترتيب. يفتحها الموظف من السجل وتُحفظ الإجابات في سجل النشاط.",
  "Thinking…": "جارٍ التفكير…",
  "This booking page is not available.": "صفحة الحجز هذه غير متاحة.",
  "This form is not available.": "هذا النموذج غير متاح.",
  "Ticket": "تذكرة",
  "Tickets": "التذاكر",
  "Time is kept in minutes and locked once approved — that lock is what lets invoicing trust it.": "يُسجَّل الوقت بالدقائق ويُقفل بعد الاعتماد، وهذا ما يجعل الفوترة تعتمد عليه.",
  "Times shown in your time zone": "الأوقات معروضة بتوقيتك المحلي",
  "Timesheets": "جداول الوقت",
  "Trade licence": "الرخصة التجارية",
  "Triggered sequences. Every send goes through the same suppression, consent and frequency checks a campaign does — an automated sequence is exactly where those get forgotten.": "تسلسلات تلقائية. يمر كل إرسال بنفس فحوص الحظر والموافقة والتكرار التي تمر بها الحملة، فالأتمتة هي حيث تُنسى عادةً.",
  "Try again": "أعد المحاولة",
  "Type": "النوع",
  "Users": "المستخدمون",
  "Vault": "الخزنة",
  "View deal": "عرض الصفقة",
  "Was this helpful?": "هل كان هذا مفيداً؟",
  "Web chat": "دردشة الموقع",
  "Web-to-lead forms for your website, landing pages and pop-ups. Every submission becomes an incoming lead with where it came from.": "نماذج لموقعك وصفحاتك المقصودة ونوافذك المنبثقة. يصبح كل إرسال عميلاً محتملاً وارداً مع مصدره.",
  "Website": "الموقع الإلكتروني",
  "Website & tracking": "الموقع والتتبع",
  "Website visitor": "زائر الموقع",
  "Weighted amount": "المبلغ المرجّح",
  "Welcome back": "مرحباً بعودتك",
  "What clients pay on a schedule, and the plans they are on.": "ما يدفعه العملاء بشكل دوري، والباقات المشتركون فيها.",
  "What each kind of person can see and do.": "ما يمكن لكل نوع من المستخدمين رؤيته وفعله.",
  "What has been billed, what is paid, and what is outstanding.": "ما تمت فوترته، وما سُدد، وما هو مستحق.",
  "What is being delivered, what it is worth, and how much of the budget is left.": "ما يجري تنفيذه، وقيمته، والمتبقي من الميزانية.",
  "What should I focus on today?": "على ماذا أركز اليوم؟",
  "What the desk promises, when it is open, and what the client owns.": "ما يلتزم به مكتب الخدمة، وأوقات عمله، وما يملكه العميل.",
  "What was planned against what happened, and the costs that arrive whether anyone books them or not.": "المخطط مقابل الفعلي، والتكاليف التي تأتي سواء سُجلت أم لا.",
  "What we are building for you, and where it stands.": "ما ننفذه لك، وأين وصل.",
  "What we have proposed, and where each one stands.": "ما اقترحناه، وحالة كل عرض.",
  "WhatsApp": "واتساب",
  "WhatsApp opt-in": "موافقة واتساب",
  "WhatsApp, Instagram, Telegram and your website land in one inbox.": "واتساب وإنستغرام وتيليجرام وموقعك في صندوق وارد واحد.",
  "WhatsApp, Instagram, Telegram and your website land in one inbox. Bots qualify, pipelines move, invoices go out with VAT.": "واتساب وإنستغرام وتيليجرام وموقعك في صندوق وارد واحد. الروبوتات تؤهّل العملاء، والمسارات تتقدم، والفواتير تُرسل مع ضريبة القيمة المضافة.",
  "When something happens, if the conditions hold, do this. Every run is logged — including the ones that did not match.": "عند وقوع حدث وتحقق الشروط، نفّذ هذا. يُسجَّل كل تشغيل، حتى غير المطابق منها.",
  "Who at each client can sign in, and what they can see once they do.": "من يمكنه الدخول من كل عميل، وما يمكنه رؤيته.",
  "Who must never be contacted, and the limits every send is held to.": "من يجب عدم التواصل معهم أبداً، والحدود التي يلتزم بها كل إرسال.",
  "Won": "رابحة",
  "Work board": "لوحة العمل",
  "Work email": "البريد الإلكتروني للعمل",
  "Workflows": "سير العمل",
  "Write once, post to your Facebook pages and Instagram accounts — now or at the best time.": "اكتب مرة واحدة وانشر على صفحات فيسبوك وحسابات إنستغرام، الآن أو في أفضل وقت.",
  "Yes": "نعم",
  "You are booked": "تم الحجز",
  "You do not have access to this page": "لا تملك صلاحية الوصول إلى هذه الصفحة",
  "Your DovoCRM subscription. Prices are in dirhams, per user, plus VAT.": "اشتراكك في DovoCRM. الأسعار بالدرهم لكل مستخدم، تُضاف إليها ضريبة القيمة المضافة.",
  "Your account": "حسابك",
  "Your calendar of customer meetings, and booking pages that let customers choose a free slot — round robin across a team included.": "تقويم اجتماعاتك مع العملاء، وصفحات حجز تتيح لهم اختيار موعد متاح، مع التوزيع الدوري على الفريق.",
  "Your name": "اسمك",
  "Your own record types — properties, vehicles, units, policies — with their own fields, linked to leads, contacts, companies and deals.": "أنواع سجلات خاصة بك، مثل العقارات والمركبات والوحدات والوثائق، بحقولها الخاصة ومرتبطة بالعملاء والشركات والصفقات.",
  "Your role's view of the business. Every tile is a live query, and every one respects what you are allowed to see.": "نظرة دورك على العمل. كل مربع استعلام مباشر يحترم ما يحق لك رؤيته.",
  "Your subscriptions and support agreements. Ask for a change and it reaches your account manager.": "اشتراكاتك واتفاقيات الدعم. اطلب أي تغيير ليصل إلى مدير حسابك.",
  "companies": "شركات",
  "contacts": "جهات اتصال",
  "deals": "صفقات",
  "default": "افتراضي",
  "leads": "عملاء محتملين",
  "left today": "متبقية اليوم",
  "minutes": "دقيقة",
  "now": "الآن",
  "of": "من",
  "selected": "محدد",
  "total": "الإجمالي",
  "weighted": "مرجّح",
  "{count} could not be deleted": "تعذّر حذف {count}",
};
